function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { agentrankinggoodsadd, agentrankinggoodspage } from '@/api/marketing';
import { productActivityListApi, productDeleteApi, putOnShellApi, offShellApi, productHeadersApi } from '@/api/product';
import { EventBus } from '@/utils/eventBus'; // 引入事件总线
import { merCategoryListApi } from '@/api/merchant';
import { mapGetters } from 'vuex';
import store from '@/store';
export default {
  name: 'GoodList',
  props: {
    handleNum: {
      type: String,
      default: ''
    },
    names: {
      type: String,
      default: ''
    },
    activityScoreId: {
      type: String,
      default: ''
    },
    checked: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      templateRadio: 0,
      props: {
        value: 'id',
        label: 'name',
        children: 'childList',
        expandTrigger: 'hover',
        checkStrictly: false,
        emitPath: false,
        multiple: false
      },
      merProps: {
        value: 'id',
        label: 'name',
        children: 'merchantList',
        expandTrigger: 'hover',
        //checkStrictly: true,
        emitPath: false,
        multiple: true
      },
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 15,
        categoryId: '',
        name: '',
        isShow: '',
        merIds: '',
        merStars: ''
      },
      merIds: [],
      name: '',
      categoryList: [],
      imgList: [],
      multipleSelection: [],
      checkedPage: [],
      isChecked: false,
      isIndex: 0,
      checkBox: [],
      merSelect: [],
      checkedIds: [] // 订单当前页选中的数据
    };
  },
  computed: {},
  mounted: function mounted() {
    var _this = this;
    if (!store.getters.adminProductClassify.length) store.dispatch('product/getAdminProductClassify');
    this.$nextTick(function () {
      _this.categoryList = store.getters.adminProductClassify;
    });
    this.getMerchantList();
    this.getList();
    if (this.names === '活动') {
      this.getagentactivityscoregoodspage();
    } else {
      if (this.checked.length) {
        var _this$checked = _toArray(this.checked),
          arr2 = _arrayLikeToArray(_this$checked).slice(0);
        this.checkBox = arr2;
        this.checkedIds = arr2.map(function (item) {
          return item.id;
        });
      }
    }
  },
  methods: {
    getagentactivityscoregoodspage: function getagentactivityscoregoodspage() {
      var _this2 = this;
      agentrankinggoodspage({
        activityScoreId: this.activityScoreId,
        limit: 99999,
        page: 1
      }).then(function (res) {
        console.log(res.list, 'this.activityScoreId');
        _this2.checked == res.list;
        _this2.checkedIds = res.list.map(function (item) {
          return item.activityScoreGoodsId;
        });
        console.log(_this2.checkedIds, '选中');
      });
    },
    // open(e,val) {
    //   this.$prompt('请输入分值', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     inputPattern: /^\d+$/,
    //     inputErrorMessage: '分值只能包含数字'
    //   }).then(({ value }) => {
    //     val.score=value
    //     console.log( this.tableData.data)
    //     // agentactivityscoregoodsedit({id:val.id,goodsCount:value}).then(res=>{
    //     //   this.$message.success('编辑分值成功');
    //     //   this.getList();
    //     // })
    //     // this.$message({
    //     //   type: 'success',
    //     //   message: '你的分值是: ' + value
    //     // });
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '取消输入'
    //     });
    //   });
    // },
    onInput: function onInput(e) {
      this.$forceUpdate();
    },
    // 商户列表
    getMerchantList: function getMerchantList() {
      var _this3 = this;
      merCategoryListApi().then(function (res) {
        _this3.merSelect = res;
      });
    },
    changeType: function changeType(v) {
      this.isChecked = v;
      var index = this.checkedPage.indexOf(this.tableFrom.page);
      this.isIndex = index;
      this.checkedPage.push(this.tableFrom.page);
      if (index > -1) {
        this.checkedPage.splice(index, 1);
      }
      this.syncCheckedId(v);
    },
    changeOne: function changeOne(v, order) {
      if (v) {
        var index = this.checkedIds.indexOf(order.id);
        if (index === -1) {
          this.checkedIds.push(order.id);
          this.checkBox.push(order);
        }
      } else {
        var _index = this.checkedIds.indexOf(order.id);
        if (_index > -1) {
          this.checkedIds.splice(_index, 1);
          this.checkBox.splice(_index, 1);
        }
      }
    },
    syncCheckedId: function syncCheckedId(o) {
      var _this4 = this;
      var ids = this.tableData.data.map(function (v) {
        return v.id;
      });
      if (o) {
        this.tableData.data.forEach(function (item) {
          var index = _this4.checkedIds.indexOf(item.id);
          if (index === -1) {
            _this4.checkedIds.push(item.id);
            _this4.checkBox.push(item);
          }
        });
      } else {
        this.tableData.data.forEach(function (item) {
          var index = _this4.checkedIds.indexOf(item.id);
          if (index > -1) {
            _this4.checkedIds.splice(index, 1);
            _this4.checkBox.splice(index, 1);
          }
        });
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var tables = [];
      val.map(function (item) {
        tables.push({
          src: item.image,
          id: item.id
        });
      });
      this.multipleSelection = tables;
    },
    ok: function ok() {
      var _this5 = this;
      if (this.names == '活动') {
        console.log(this.checkBox);
        var checkBoxlsit = this.checkBox.map(function (item) {
          return {
            productId: item.id,
            goodsCount: Number(item.score)
          };
        });
        agentrankinggoodsadd({
          activityScoreId: this.activityScoreId,
          activityScoreGoodsList: checkBoxlsit
        }).then(function (res) {
          _this5.$message.success('添加成功');
          _this5.$emit('getStoreItem', _this5.checkBox);
          EventBus.$emit('requestCompleted', _this5.checkBox);
        });
      } else {
        this.$emit('getStoreItem', this.checkBox);
      }
    },
    getTemplateRow: function getTemplateRow(row) {
      this.$emit('getStoreItem', row);
    },
    getList: function getList(num) {
      var _this6 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.name = encodeURIComponent(this.name);
      this.tableFrom.merIds = this.merIds.toString();
      productActivityListApi(this.tableFrom).then(function (res) {
        _this6.tableData.data = res.list;
        _this6.tableData.total = res.total;
        // res.list.map((item) => {
        //   this.imgList.push(item.image)
        // })
        _this6.tableData.data.forEach(function (item) {
          _this6.checked.forEach(function (element) {
            console.log(element, 'element.id');
            if (Number(item.id) === (_this6.names === '活动' ? Number(element.activityScoreGoodsId) : Number(element.id))) {
              _this6.$nextTick(function () {
                _this6.$refs.multipleTable.toggleRowSelection(item, true);
              });
            }
          });
        });
        _this6.listLoading = false;
      }).catch(function (res) {
        _this6.listLoading = false;
        _this6.$message.error(res.message);
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    }
  }
};